// extracted by mini-css-extract-plugin
module.exports = {"eulaButton":"styles_eulaButton__1F3Y9","eulaText":"styles_eulaText__XGRqG","eulaActionContainer":"styles_eulaActionContainer__27Bn8","eulaContainer":"styles_eulaContainer__3K7GN"};